<script>
    import Menu from "../components/Menu.svelte";

    import {
        Card,
        Col,
        Container,
        ListGroup,
        ListGroupItem,
        Row
    } from "sveltestrap";
</script>

<Menu />

<Container fluid>
    <Row>
        <Col lg="4"  md="3" sm="12" xs="12">
            <Card color="light" class="mb-2">
                <ListGroup>
                    <ListGroupItem light>Test</ListGroupItem>
                </ListGroup>
            </Card>
        </Col>
        <Col lg="4" md="6" sm="12" xs="12">
            <Card color="light">
                bbb
            </Card>
        </Col>
        <Col lg="4"  md="3" sm="12" xs="12"></Col>
    </Row>
</Container>